// Inspect only known Apollo error containers for one of `codes`; never expose
// provider messages.
export function findErrorCode<K extends string>(
  value: unknown,
  codes: Readonly<Record<K, string>>,
  depth = 0,
): K | null {
  if (!value || typeof value !== 'object' || depth > 3) return null;
  const error = value as Record<string, unknown>;
  const extensions = error.extensions as Record<string, unknown> | undefined;
  for (const candidate of [extensions?.code, error.code, error.message]) {
    if (typeof candidate === 'string' && Object.prototype.hasOwnProperty.call(codes, candidate)) {
      return candidate as K;
    }
  }
  const nested = findErrorCode(error.error, codes, depth + 1);
  if (nested) return nested;
  for (const list of [error.graphQLErrors, error.errors]) {
    if (!Array.isArray(list)) continue;
    for (const item of list.slice(0, 20)) {
      const code = findErrorCode(item, codes, depth + 1);
      if (code) return code;
    }
  }
  return null;
}
